/* sts-home.js - v4 homepage behaviour. Why-notes: docs/new-theme-v4/asset-notes/sts-home-js.md */
(function () {
  'use strict';

  var w = window;
  var STS = (w.STS = w.STS || {});
  if (STS.home) return;

  function envBase(key, fallback, hard) {
    var E = STS.env;
    return String((E && E.get) ? E.get(key, fallback || hard) : (fallback || hard));
  }

  var TYPES = ['DSPT', 'DSNT', 'DSPW', 'DSNW', 'OSPT', 'OSNT', 'OSPW', 'OSNW',
    'ORPT', 'ORNT', 'ORPW', 'ORNW', 'DRPT', 'DRNT', 'DRPW', 'DRNW'];

  function all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function reducedMotion() {
    return !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* The type, from the state engine when it is there and from the <html>
     attribute when it is not - the attribute is written before first paint, so it
     is available even if assets/sts-state.js failed to load. */
  function currentType() {
    var t = (STS.state && STS.state.type) || document.documentElement.getAttribute('data-sts-type');
    t = (t || '').toUpperCase();
    return TYPES.indexOf(t) > -1 ? t : null;
  }

  /* Every event goes through assets/sts-track.js, which owns consent and the ad
     gate. The head stub queues calls made before it loads; analytics is never
     allowed to break the page. */
  function track(name, params) {
    try {
      if (typeof w.stsTrack === 'function') w.stsTrack(name, params || {});
    } catch (e) { /* never load bearing */ }
  }

  function parseJSON(raw) {
    try { return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
  }

  // ------------------------------------------------------------ type hrefs

  function fillTypeHrefs() {
    var type = currentType();
    if (!type) return;
    var handle = type.toLowerCase();
    all('[data-sts-type-href]').forEach(function (el) {
      var tpl = el.getAttribute('data-sts-type-href');
      if (!tpl) return;
      /* {TYPE}: the code as is (a filter value, case-sensitive); {type}: lower case. */
      el.setAttribute('href', tpl.replace(/\{TYPE\}/g, type).replace(/\{type\}/g, handle));
    });
  }

  // ------------------------------------------------------------ the slider

  function initSlider(root) {
    var slides = all('[data-sts-slide]', root);
    if (slides.length < 2) return;

    var dots = all('[data-sts-slider-dot]', root);
    var pauseBtn = root.querySelector('[data-sts-slider-pause]');
    var interval = parseInt(root.getAttribute('data-sts-slider-interval'), 10) || 5000;
    var wantsAuto = root.getAttribute('data-sts-slider-autoplay') === 'true';
    var index = 0;
    var timer = null;
    var userPaused = false;
    var hovered = false;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        var on = n === index;
        if (on) {
          slide.setAttribute('data-sts-slide-active', '');
          slide.removeAttribute('aria-hidden');
        } else {
          slide.removeAttribute('data-sts-slide-active');
          slide.setAttribute('aria-hidden', 'true');
        }
        /* Every slide carries CTA links. aria-hidden takes them out of the
           accessibility tree but not out of the tab order, and the only thing
           doing that today is `visibility:hidden` on an inactive slide in
           assets/sts-home.css. That is one declaration standing between the
           page and a Tab that lands on a link nobody can see, on a slide that
           may rotate away under the visitor's hands. inert does both, from the
           same boolean that already decides everything else here. */
        if ('inert' in HTMLElement.prototype) slide.inert = !on;
      });
      dots.forEach(function (dot, n) {
        if (n === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    /* Auto-advance stops for every reason the spec lists (AC 33): the pause
       control, hover, focus anywhere inside the slider, a hidden tab, and
       prefers-reduced-motion, under which it never starts at all. */
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function start() {
      stop();
      if (!wantsAuto || userPaused || hovered || reducedMotion()) return;
      if (document.hidden) return;
      timer = setInterval(function () { show(index + 1); }, interval);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.getAttribute('data-sts-slider-dot'), 10) || 0);
        start();
      });
    });

    if (pauseBtn) {
      if (reducedMotion() || !wantsAuto) {
        pauseBtn.hidden = true;
      }
      pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        var label = pauseBtn.getAttribute(userPaused ? 'data-sts-label-play' : 'data-sts-label-pause');
        if (label) pauseBtn.setAttribute('aria-label', label);
        root.setAttribute('data-sts-slider-paused', userPaused ? 'true' : 'false');
        start();
      });
    }

    root.addEventListener('mouseenter', function () { hovered = true; stop(); });
    root.addEventListener('mouseleave', function () { hovered = false; start(); });
    root.addEventListener('focusin', function () { hovered = true; stop(); });
    root.addEventListener('focusout', function (ev) {
      if (root.contains(ev.relatedTarget)) return;
      hovered = false;
      start();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    show(0);
    start();
  }

  // --------------------------------------------------------- the 16-type grid

  /* The prototype's explore-first grid (sections/sts-type-grid.liquid). A click,
     Enter or Space PICKS a type: the panel shows its code, number and letters
     and a "Shop {CODE} products" link. Hover and focus preview a type; leaving
     the clusters returns the panel to the picked one. The cells are real links,
     so with no script a click still reaches the collection. */
  function initTypeGrid(root) {
    var panel = root.querySelector('[data-sts-decode]');
    if (!panel) return;
    var slot = function (k) { return panel.querySelector('[data-sts-decode-slot="' + k + '"]'); };
    var titleSlot = slot('title'), bodySlot = slot('body'), shop = slot('shop');
    if (!titleSlot || !bodySlot) return;

    /* innerHTML, not text: the default title is a Tap/Click span pair. */
    var defaults = { title: titleSlot.innerHTML, body: bodySlot.innerHTML };
    var picked = null;

    function paint(link) {
      if (!link) {
        titleSlot.innerHTML = defaults.title;
        bodySlot.innerHTML = defaults.body;
        panel.removeAttribute('data-sts-type');
        if (shop) shop.hidden = true;
        return;
      }
      titleSlot.textContent = link.getAttribute('data-sts-decode-title') || '';
      bodySlot.textContent = link.getAttribute('data-sts-decode-words') || '';
      panel.setAttribute('data-sts-type', link.getAttribute('data-sts-type') || '');
      if (shop) {
        shop.href = link.getAttribute('data-sts-decode-href') || link.getAttribute('href');
        shop.textContent = link.getAttribute('data-sts-decode-shop') || '';
        shop.hidden = false;
      }
    }

    function cell(ev) {
      var el = ev.target;
      while (el && el !== root) {
        if (el.hasAttribute && el.hasAttribute('data-sts-decode-words')) return el;
        el = el.parentNode;
      }
      return null;
    }

    function pick(link) {
      if (picked) picked.removeAttribute('data-sts-picked');
      picked = link;
      link.setAttribute('data-sts-picked', '');
      paint(link);
    }

    function preview(ev) { var c = cell(ev); if (c) paint(c); }

    root.addEventListener('mouseover', preview);
    root.addEventListener('focusin', preview);
    root.addEventListener('click', function (ev) {
      var c = cell(ev);
      if (!c || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button > 0) return;
      ev.preventDefault();
      pick(c);
    });
    root.addEventListener('keydown', function (ev) {
      var c = (ev.key === ' ' || ev.key === 'Spacebar') && cell(ev);
      if (!c) return;
      ev.preventDefault();
      pick(c);
    });
    var families = root.querySelector('.sts-typegrid__families') || root;
    families.addEventListener('mouseleave', function () { paint(picked); });
  }

  function markOwnType() {
    var type = currentType();
    all('.sts-typegrid__link').forEach(function (link) {
      if (type && link.getAttribute('data-sts-type') === type) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  // ------------------------------------------------- the glance card (H5)

  var SUB_OPT_OUT = 'sts.sp.subOptOut';   // assets/sts-profile.js owns this key too
  var ROUTINE_CODE = 'SUBSCRIBE10';       // the Skin Profile's add-all applies it too
  var PLAN_WAIT_MS = 5000;

  function lsGet(k) { try { return w.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { w.localStorage.setItem(k, v); } catch (e) { /* blocked */ } }
  function lsDel(k) { try { w.localStorage.removeItem(k); } catch (e) { /* blocked */ } }

  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }

  /* One PlanStore for the page, so a refill after an add-all reuses the
     product JSON it already fetched. Waiters are how a click learns that the
     plans it needs have landed; the store only knows one onChange. */
  var planStore = null;
  var planWaiters = [];

  function plansFor(R, units) {
    if (!planStore) {
      planStore = new R.plans.Store({
        onChange: function () { planWaiters.slice().forEach(function (f) { f(); }); }
      });
    }
    var store = planStore;
    return new Promise(function (resolve) {
      var settled = false;
      var timer = null;
      function finish() {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        var i = planWaiters.indexOf(check);
        if (i > -1) planWaiters.splice(i, 1);
        resolve(store);
      }
      /* Wait on EVERY unit, the Skin Profile's rule: resolving on the first
         plan to land is how one product of four ended up subscribed. A unit
         still loading when the cap hits goes in as a one-time purchase. */
      function check() { if (!store.anyLoading(units)) finish(); }
      planWaiters.push(check);
      timer = setTimeout(finish, PLAN_WAIT_MS);
      units.forEach(function (u) { store.ensure(u); });
      check();
    });
  }

  var REGIMEN_TIMEOUT_MS = 8000;

  function withDeadline(promise, ms, label) {
    return Promise.race([
      promise,
      new Promise(function (_, reject) {
        w.setTimeout(function () { reject(new Error(label || 'timeout')); }, ms);
      })
    ]);
  }

  function fetchRegimen(cfg) {
    return withDeadline(fetchRegimenInner(cfg), REGIMEN_TIMEOUT_MS, 'regimen timeout');
  }

  function fetchRegimenInner(cfg) {
    return fetch(cfg.proxy + '/my-regimen', { credentials: 'same-origin' })
      .then(function (r) { return (r.ok && r.status !== 204) ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.widgetToken || !cfg.ec2) return null;
        return fetch(cfg.ec2 + '/widget/regimen', { headers: { Authorization: 'Bearer ' + data.widgetToken } })
          .then(function (r) { if (!r.ok) throw new Error('regimen ' + r.status); return r.json(); })
          .then(function (p) {
            if (!p || !Array.isArray(p.steps)) throw new Error('regimen payload');
            return p.steps;
          });
      });
  }

  /* A legacy routine through the Skin Profile's adapter (05-A), which re-reads
     every variant live from the Storefront API - name, handle, price, stock. */
  function legacySteps(card, cfg) {
    var L = w.STSRoutine && w.STSRoutine.legacy;
    if (!L || typeof L.read !== 'function') return Promise.resolve(null);
    return L.read({ root: card, sfDomain: cfg.sfDomain, sfToken: cfg.sfToken, country: cfg.country })
      .then(function (doc) { return (doc && Array.isArray(doc.steps)) ? doc.steps : null; });
  }

  function readPayload(card) {
    var node = card.querySelector('script[data-sts-glance-routine]');
    if (!node) return null;
    try {
      var steps = JSON.parse(node.textContent);
      return (Array.isArray(steps) && steps.length) ? steps : null;
    } catch (e) { return null; }
  }

  var routineCache = null;

  var routinePriced = true;

  function routineSteps(card, cfg) {
    if (routineCache) return Promise.resolve(routineCache);
    var printed = readPayload(card);
    var chain = printed
      ? Promise.resolve(printed)
      : fetchRegimen(cfg).then(function (steps) {
        if (steps && steps.length) { routinePriced = false; return steps; }
        return legacySteps(card, cfg);
      });
    /* A sold-out step goes in as its in-stock stand-in (Luis, 2026-10-01),
       priced and added like any other; one with none stays out, as before. */
    var F = STS.stepFallback;
    return chain.then(
      function (steps) {
        routineCache = (steps && steps.length) ? (F ? steps.map(function (s) { return F.standIn(s); }) : steps) : null;
        return routineCache;
      },
      function () { return null; }
    );
  }

  function stepFromButton(btn) {
    var price = parseFloat(btn.getAttribute('data-price'));
    return {
      dtcVariantId: btn.getAttribute('data-variant-id') || '',
      handle: btn.getAttribute('data-handle') || '',
      title: btn.getAttribute('data-title') || '',
      priceMsrp: isFinite(price) ? price : null,
      inStock: true,
      slot: btn.getAttribute('data-slot') || '',
      time: btn.getAttribute('data-time') || ''
    };
  }

  /* The Skin Profile's addableUnits(null): one unit per product, buyable only. */
  function unitsFrom(R, steps) {
    var core = R.core;
    var groups = core.buildStepGroups(steps);
    return core.dedupeByVariant(groups.map(function (g) { return steps[g.primaryIndex]; }))
      .filter(core.isBundleAddableStep);
  }

  function outOfStockCount(R, steps) {
    return R.core.dedupeByVariant(steps).filter(function (s) {
      return R.core.isAddableStep(s) && s.inStock === false;
    }).length;
  }

  /* /cart/add.js rejects the WHOLE batch when one product in it cannot be
     added, so one bottle that sold out since the page rendered would otherwise
     block the other seven. Only then are they tried one at a time. */
  function addItems(CART, items) {
    return CART.add(items).then(
      function (n) { return { added: n, failed: 0 }; },
      function (err) {
        if (items.length < 2) throw err;
        var added = 0;
        var failed = 0;
        return items.reduce(function (p, item) {
          return p.then(function () {
            return CART.add([item]).then(
              function (n) { added += n; },
              function () { failed += 1; }
            );
          });
        }, Promise.resolve()).then(function () {
          if (failed === items.length) throw err;
          return { added: added, failed: failed };
        });
      }
    );
  }

  function setBusy(btn, on) {
    var note = btn.querySelector('[data-sts-busy]');
    if (on) {
      btn.setAttribute('aria-busy', 'true');
      if (!note) {
        note = document.createElement('span');
        note.className = 'sts-vh';
        note.setAttribute('data-sts-busy', '');
        note.textContent = 'Adding to cart';
        btn.appendChild(note);
      }
    } else {
      btn.removeAttribute('aria-busy');
      if (note && note.parentNode) note.parentNode.removeChild(note);
    }
  }

  function trackRegimenAdd(kind, units, res, planned, subscribed) {
    var value = null;
    var priced = (kind === 'all') ? routinePriced : true;
    if (priced && res.added === planned && !res.failed) {
      value = units.reduce(function (sum, u) {
        var p = Number(u && u.priceMsrp);
        return isFinite(p) ? sum + p : sum;
      }, 0);
      value = Math.round(value * 100) / 100;
    }
    track('sts_regimen_add', {
      mode: kind,
      surface: 'home_glance',
      items: res.added,
      value: value,
      currency: (w.Shopify && w.Shopify.currency && w.Shopify.currency.active) || 'USD',
      subscribe: !!subscribed
    });
  }

  function initGlance(card) {
    if (card.__stsGlance) return;
    card.__stsGlance = true;

    var cfg = {
      proxy: envBase('proxyBase', card.getAttribute('data-proxy-base'), '/apps/quiz').replace(/\/+$/, ''),
      ec2: envBase('apiBase', card.getAttribute('data-ec2-base'), '').replace(/\/+$/, ''),
      profileUrl: card.getAttribute('data-profile-url') || '/pages/skin-profile',
      sfDomain: card.getAttribute('data-sf-domain') || '',
      sfToken: card.getAttribute('data-sf-token') || '',
      /* The buyer's market, so the legacy island prices the glance card on the
         market's own price list instead of the shop's. This card has no
         presentment pass of its own to correct a US figure afterwards. */
      country: card.getAttribute('data-country') || 'US'
    };
    var sub = card.querySelector('[data-sts-glance-sub]');
    var busy = false;

    if (sub) {
      sub.checked = lsGet(SUB_OPT_OUT) !== '1';
      sub.addEventListener('change', function () {
        if (sub.checked) lsDel(SUB_OPT_OUT); else lsSet(SUB_OPT_OUT, '1');
      });
    }

    /* The line on the card, never a toast (v5.1 §1.5): a clean add says
       nothing (the cart count and drawer show it); a failure, or a product
       left out, is said where the button is. */
    function say(message, tone) {
      var slot = card.querySelector('[data-sts-glance-msg]');
      if (!slot) return;
      slot.hidden = tone === 'success';
      slot.textContent = tone === 'success' ? '' : message;
    }

    /* Only a checkbox the customer can SEE may subscribe them: when its state
       hides it, every product goes in as a one-time purchase. */
    function wantsSubscribe() {
      return !!(sub && sub.checked && sub.getClientRects().length);
    }

    function run(btn, stepsPromise, kind, label) {
      var R = w.STSRoutine;
      if (!R || !R.core || !R.plans || !R.cart) {
        // The shared module never loaded: the Skin Profile can still do this.
        w.location.href = cfg.profileUrl;
        return;
      }
      var CART = R.cart;
      busy = true;
      setBusy(btn, true);

      var units = [];
      var oos = 0;
      var subscribed = false;
      var planned = 0;

      stepsPromise
        .then(function (steps) {
          if (!steps || !steps.length) throw new Error('NO_ROUTINE');
          units = unitsFrom(R, steps);
          oos = outOfStockCount(R, steps);
          if (!units.length) throw new Error(oos ? 'ALL_OUT' : 'NO_ROUTINE');
          return wantsSubscribe() ? plansFor(R, units) : null;
        })
        .then(function (store) {
          var subs = new Map();
          if (store) store.subscribeAll(store.defaultSubUnits(units), subs, null);
          var items = CART.buildItems(units, subs);
          planned = items.length;
          subscribed = items.some(function (i) { return i.selling_plan; });
          return addItems(CART, items);
        })
        .then(function (res) {
          var code = kind === 'all' ? CART.applyDiscountCodes([ROUTINE_CODE]) : Promise.resolve(null);
          return code
            .then(function () { return CART.read(); })
            .then(function (cart) { CART.notifyChanged(cart); return CART.applyCashbackLines(); })
            .then(function () { return CART.read(); })
            .then(function (cart) { CART.notifyChanged(cart); return res; });
        })
        .then(function (res) {
          if (res.added) trackRegimenAdd(kind, units, res, planned, subscribed);
          var already = Math.max(0, planned - res.added - res.failed);
          var msg;
          if (kind === 'refill') {
            msg = res.added
              ? label + ' added to your cart. Its refill date resets once the order ships.'
              : label + ' is already in your cart.';
          } else if (!res.added && !res.failed) {
            msg = kind === 'all'
              ? 'Everything in your routine is already in your cart.'
              : 'Those products are already in your cart.';
          } else {
            msg = plural(res.added, 'product', 'products') + ' added to your cart.';
            if (already) msg += ' ' + already + (already === 1 ? ' was' : ' were') + ' already there.';
            if (subscribed && res.added) msg += ' Subscribe & Save is on wherever a refill plan exists.';
          }
          if (res.failed) msg += ' ' + plural(res.failed, 'product', 'products') + ' could not be added.';
          if (oos) msg += ' ' + plural(oos, 'product is', 'products are') + ' out of stock right now.';
          say(msg, res.failed || oos ? null : 'success');
        })
        .catch(function (err) {
          var m = String((err && err.message) || err || '');
          if (m === 'NO_ROUTINE') {
            say('We could not load your routine just now. Open your Skin Profile to add it.', 'error');
          } else if (m === 'ALL_OUT') {
            say('Everything in this selection is out of stock right now.', 'error');
          } else {
            /* Shopify's reason or a plain line, never the raw exception (STS.shopperError). */
            var f = (window.STS || {}).shopperError;
            say('We could not add that to your cart. ' + (f ? f(err) : 'Please try again.'), 'error');
          }
        })
        .then(function () {
          busy = false;
          setBusy(btn, false);
        });
    }

    /* The routine is read now rather than on the first tap, so a sold-out
       product's tile shows its stand-in (patchStandIns); the tap reuses it. */
    if (STS.stepFallback && card.querySelector('.sts-hero__swatch[data-sts-vid]')) routineSteps(card, cfg).then(patchStandIns);

    card.addEventListener('click', function (ev) {
      var btn = ev.target && ev.target.closest
        ? ev.target.closest('[data-sts-glance-add],[data-sts-glance-refill],[data-sts-glance-refill-all]')
        : null;
      if (!btn || !card.contains(btn)) return;
      ev.preventDefault();
      if (busy) return;

      if (btn.hasAttribute('data-sts-glance-add')) {
        run(btn, routineSteps(card, cfg), 'all');
      } else if (btn.hasAttribute('data-sts-glance-refill')) {
        run(btn, Promise.resolve([stepFromButton(btn)]), 'refill', btn.getAttribute('data-title') || 'That product');
      } else {
        var steps = all('[data-sts-glance-refill]', card).map(stepFromButton);
        run(btn, Promise.resolve(steps), 'refills');
      }
    });
  }

  // ------------------------------------ Picked for your type, typed guest (W21d-b)

  var ROW_TIMEOUT_MS = 4000;

  function ownedKeys(type) {
    var keys = {};
    function add(v) {
      if (v === null || v === undefined || v === '') return;
      keys[String(v).split('/').pop().toLowerCase()] = true;
    }
    function take(list) {
      if (!Array.isArray(list)) return;
      list.forEach(function (s) {
        if (!s || typeof s !== 'object') return;
        add(s.handle);
        add(s.productId); add(s.product_id);
        add(s.variantId); add(s.variant_id); add(s.dtcVariantId); add(s.cprvariantid);
      });
    }
    take(parseJSON(lsGet('customerRoutine')));
    var saved = parseJSON(lsGet('slqSavedRegimen'));
    if (saved && (!saved.skinType || String(saved.skinType).toUpperCase() === type)) take(saved.steps);
    return keys;
  }

  function isOwned(li, owned) {
    var card = li.querySelector('[data-sts-card]');
    if (!card) return true; // not a card: never inject it
    var h = (card.getAttribute('data-handle') || '').toLowerCase();
    return !!(owned[h] || owned[card.getAttribute('data-product-id')] || owned[card.getAttribute('data-variant-id')]);
  }

  function fetchText(url, ms) {
    return new Promise(function (resolve, reject) {
      var ctrl = typeof w.AbortController === 'function' ? new w.AbortController() : null;
      var settled = false;
      var timer = setTimeout(function () {
        if (settled) return;
        settled = true;
        if (ctrl) ctrl.abort();
        reject(new Error('timeout'));
      }, ms);
      fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) {
          if (!r.ok) throw new Error('http_' + r.status);
          return r.text();
        })
        .then(function (text) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          resolve(text);
        }, function (err) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          reject(err);
        });
    });
  }

  /* Holds the slot at the height it already has, so fewer or shorter cards
     cannot pull the page up under the reader. Not done for an empty slot: its
     height is a reserve, not content. */
  function swapCards(slot, nodes) {
    var h = slot.children.length ? slot.offsetHeight : 0;
    if (h) slot.style.minHeight = h + 'px';
    while (slot.firstChild) slot.removeChild(slot.firstChild);
    nodes.forEach(function (n) { slot.appendChild(n); });
  }

  function fillPicked(slot) {
    var src = slot.getAttribute('data-sts-row-src');
    if (!src) return;
    var row = slot.closest('.sts-row');
    if (!slot.__stsFallback) slot.__stsFallback = Array.prototype.slice.call(slot.children);

    var type = currentType();
    if (!type) {
      /* The type went away mid-session (a sign-out in another tab, the staff
         simulator): put the server's cards back. */
      if (slot.__stsType) {
        slot.__stsType = null;
        swapCards(slot, slot.__stsFallback);
        slot.removeAttribute('data-sts-row-filled');
      }
      return;
    }
    if (slot.__stsType === type) return; // filled, failed or in flight for this type
    slot.__stsType = type;

    var count = parseInt(slot.getAttribute('data-sts-row-count'), 10) || 6;
    var url = src.replace(/\{type\}/gi, type.toLowerCase());
    slot.setAttribute('aria-busy', 'true');

    fetchText(url, ROW_TIMEOUT_MS)
      .then(function (html) {
        if (slot.__stsType !== type) return; // superseded by a newer type
        var box = document.createElement('template');
        box.innerHTML = html;
        var list = box.content ? box.content.querySelector('[data-sts-row-fragment]') : null;
        if (!list) throw new Error('parse');
        var owned = ownedKeys(type);
        var wanted = STS.fit ? STS.fit.wantedSubs() : [];
        var items = Array.prototype.slice.call(list.children)
          .filter(function (li) { return !isOwned(li, owned) && !isUnfit(li, type, wanted); })
          .slice(0, count);
        if (!items.length) throw new Error('empty');
        swapCards(slot, items);
        slot.setAttribute('data-sts-row-filled', type);
        if (row) row.removeAttribute('data-sts-row-empty');
        pruneRows();
      })
      .catch(function (err) {
        if (slot.__stsType !== type) return;
        var m = String((err && err.message) || '');
        var reason = /^(timeout|parse|empty|http_\d+)$/.test(m) ? m
          : (err && err.name === 'AbortError') ? 'timeout' : 'network';
        track('sts_slot_failed', { slot: 'home_picked', reason: reason });
        /* The fallback cards are still there. A slot that never had any is only
           a reserved gap, and a gap is worse than no row. */
        if (!slot.children.length && row) row.style.display = 'none';
      })
      .then(function () { slot.removeAttribute('aria-busy'); });
  }

  function fillRows() {
    all('[data-sts-row-slot="picked"]').forEach(fillPicked);
    pruneRows();
  }

  /* Robert 6.3.2 #01: a typed shopper is never shown a "Not for your type" or
     "Not for your sensitivity" card in a homepage row. The server already drops
     them for a signed-in type; for a guest it draws spares (data-sts-row-spare)
     and this hides the unfit cards for the device's type, then shows cards in
     order until the row holds `count` again. With no type the row goes back to
     exactly what the server drew. Unrated cards and Shop-by-any-type cards
     (data-sts-for, judged for THEIR type) always stay. */
  function isUnfit(li, type, wanted) {
    var card = li.querySelector('[data-sts-card]');
    if (!card || !STS.fit || card.hasAttribute('data-sts-for')) return false;
    var list = function (k) { return (card.getAttribute(k) || '').split(/\s+/).filter(Boolean); };
    var fit = STS.fit.verdict(list('data-sts-approved'), list('data-sts-sens'), type, wanted).fit;
    return fit === 'barred' || fit === 'subtype';
  }

  function pruneRows() {
    var type = currentType();
    var wanted = (type && STS.fit) ? STS.fit.wantedSubs() : [];
    all('[data-sts-home-row] [data-sts-row-count]').forEach(function (list) {
      var items = Array.prototype.slice.call(list.children);
      if (!items.length) return; // an empty guest slot is a reserve, not a row
      var count = parseInt(list.getAttribute('data-sts-row-count'), 10) || 6;
      var shown = 0;
      items.forEach(function (li) {
        var keep = type ? (shown < count && !isUnfit(li, type, wanted))
          : !li.hasAttribute('data-sts-row-spare');
        li.hidden = !keep;
        if (keep) shown += 1;
      });
      /* Every card unfit and no spare left: no row beats a row of nothing. */
      var row = list.closest('.sts-row');
      if (row) row.style.display = shown ? '' : 'none';
    });
  }

  // ------------------------------- the glance tiles, from the device (H5 / W21d-b)

  var GLANCE_MAX = 12;                                  // the server's `limit: 12`
  var REGIMEN_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

  /* Fresh, and for THIS type: a cache under another code is someone else's
     routine on a shared device. Same test as sts-steps.js cachedRegimen(). */
  function cachedRegimenSteps(type) {
    var c = parseJSON(lsGet('slqSavedRegimen'));
    if (!c || !Array.isArray(c.steps) || !c.steps.length) return null;
    if (!c.cachedAt || (Date.now() - c.cachedAt) > REGIMEN_MAX_AGE_MS) return null;
    if (type && c.skinType && String(c.skinType).toUpperCase() !== type) return null;
    return c.steps;
  }

  function deviceSteps() {
    var type = currentType();
    if (!type) return Promise.resolve(null);
    var chain = (typeof STS.previewRoutine === 'function')
      ? STS.previewRoutine().then(function (pv) { return pv ? pv.steps : null; })
      : Promise.resolve(null);
    return chain.then(function (steps) {
      if (steps && steps.length) return steps;
      steps = cachedRegimenSteps(type);
      if (steps && steps.length) return steps;
      steps = parseJSON(lsGet('customerRoutine'));
      return (Array.isArray(steps) && steps.length) ? steps : widgetSteps();
    });
  }

  /* STS-ROUTINE-MISSING-1014 follow-up: nothing on the server or the device
     (a signed-in account with no routine, a guest whose token read is still
     out) -> the routine the My routine widget shows, the type's default when
     nothing else, so the glance never sits there as text under a panel full
     of products. The widget's sts:routine:ready (any type: the caller redraws
     when the type moved on), its current() when it has already read, and
     STS.typeRoutine on a page without the widget. */
  function widgetSteps() {
    var W = STS.routineWidget, c = W && W.current ? W.current() : null;
    if (c && c.steps && c.steps.length) return Promise.resolve(c.steps);
    if (document.querySelector('[data-sts-rw]')) {
      return new Promise(function (resolve) {
        document.addEventListener('sts:routine:ready', function on(e) {
          var x = (e && e.detail) || {};
          if (!x.steps || !x.steps.length) return;
          document.removeEventListener('sts:routine:ready', on);
          resolve(x.steps);
        });
      });
    }
    var TR = STS.typeRoutine;
    return TR && TR.forVisitor ? TR.forVisitor().then(function (r) { return r && r.steps && r.steps.length ? r.steps : null; }, function () { return null; }) : Promise.resolve(null);
  }

  /* One product per variant, else per handle, else per step. */
  function glanceKey(step) {
    var v = step.variantId || step.variant_id || step.dtcVariantId;
    return v ? 'v' + String(v).split('/').pop() : step.handle ? 'h' + step.handle : 'i' + step.srcIndex;
  }

  /* The name: title (native tooltip), data-name (the CSS tooltip) and the
     picture's alt. */
  /* The name: data-name for the CSS tooltip (no title: two tooltips), and the
     tile's one accessible name, "{name}, step {n}{, used morning and night}".
     The visible number and badge are aria-hidden so nothing is read twice. */
  function nameTile(li, name) {
    li.__stsTitle = name;
    if (name) li.setAttribute('data-name', name);
    li.setAttribute('aria-label', (name ? name + ', ' : '') + 'step ' + li.__stsN +
      (li.__stsB ? ', used morning and night' : ''));
  }

  /* Emma, 2026-10-01: an earlier quiz's AM 1, AM 5 and PM 1 drew as empty
     tiles. Legacy items (customer_info.routine) carry a variant id and maybe
     a stored imageUrl, never a handle, so one without a (live) imageUrl had no
     picture anywhere. Every tile now goes through assets/sts-step-fallback.js
     (loaded before this file): its picture, else its product's by handle or
     variant, else the category icon. The handle-only fetch it replaces did
     the first two for a v4 step and nothing for a legacy one. */
  function tileImg(li, step) {
    var old = li.querySelector('.sts-hero__swatch-img');
    if (old) old.remove();
    var img = new Image(240, 240);
    img.className = 'sts-hero__swatch-img';
    img.alt = '';
    img.decoding = 'async';
    STS.stepFallback.paint(img, step, 240);
    li.insertBefore(img, li.firstChild);
    li.classList.add('sts-hero__swatch--img');
  }

  /* The tile's step, read back off a server-drawn tile (sections/sts-hero.liquid). */
  function tileStep(li) {
    return { slot: li.getAttribute('data-sts-slot'), dtcVariantId: li.getAttribute('data-sts-vid'), handle: li.getAttribute('data-sts-handle'), title: li.getAttribute('data-name') };
  }

  /* Server-drawn tiles: one with no picture, or whose picture failed or
     loaded as a spacer under 8px (now or later: it is lazy), gets the
     fallback. */
  function repairTiles() {
    if (!STS.stepFallback) return;
    all('.sts-hero__swatch[data-sts-slot]').forEach(function (li) {
      if (li.__stsFix) return;
      li.__stsFix = true;
      var img = li.querySelector('.sts-hero__swatch-img');
      function fix() { if (img.isConnected && img.naturalWidth < 8) tileImg(li, tileStep(li)); }
      if (!img || (img.complete && img.naturalWidth < 8)) { tileImg(li, tileStep(li)); return; }
      img.addEventListener('error', fix);
      img.addEventListener('load', fix);
    });
  }

  /* A sold-out product's stand-in (STS.stepFallback.standIn), named on its tile. */
  function standInName(s) {
    return (s.displayTitle || s.title) + ', picked for now: ' + s.substitutedFrom + ' is out of stock';
  }

  /* The server drew the sold-out product; the rest of the site shows its
     stand-in, so its tiles do too. */
  function patchStandIns(steps) {
    if (!STS.stepFallback) return;
    (steps || []).forEach(function (s) {
      var was = s && s.substituted && s.oosOriginal ? String(s.oosOriginal.dtcVariantId || '').split('/').pop() : '';
      if (!/^\d+$/.test(was)) return;
      all('.sts-hero__swatch[data-sts-vid="' + was + '"]').forEach(function (li) {
        var n = li.querySelector('.sts-hero__swatch-n');
        tileImg(li, s);
        li.__stsN = n ? n.textContent : '';
        li.__stsB = /--b1/.test(li.className);
        nameTile(li, standInName(s));
      });
    });
  }

  /* The device routine's step count, into the lines the server could only
     print without one (sections/sts-hero.liquid, data-sts-steps-tpl). */
  /* count = steps, morning plus evening; products = distinct products. */
  function fillStepCount(count, type, products) {
    all('[data-sts-steps-tpl]').forEach(function (el) {
      el.textContent = el.getAttribute('data-sts-steps-tpl')
        .replace(/\[products\]/g, products + (products === 1 ? ' product' : ' products'))
        .replace(/\[steps\] steps/g, count + (count === 1 ? ' step' : ' steps'))
        .replace(/\[steps\]/g, count).replace(/\{type\}/g, type || '');
      el.hidden = false;
    });
    all('[data-sts-steps-fallback]').forEach(function (el) { el.hidden = true; });
  }

  /* The glance tile row hides its scrollbar, so it says it scrolls another way:
     [data-sts-more] (a right-edge fade, assets/sts-home.css) while tiles are
     still off to the right, and a tab stop so a keyboard can scroll it, only
     while it overflows. Idempotent; re-run after the guest tiles are drawn. */
  function watchSwatchRow(row) {
    if (row.__stsSync) { row.__stsSync(); return; }
    var sync = row.__stsSync = function () {
      var over = row.scrollWidth > row.clientWidth + 1;
      row.toggleAttribute('data-sts-more', over && row.scrollLeft + row.clientWidth < row.scrollWidth - 1);
      if (over) {
        row.tabIndex = 0;
        row.setAttribute('aria-label', 'Routine steps');
      } else {
        row.removeAttribute('tabindex');
        row.removeAttribute('aria-label');
      }
    };
    row.addEventListener('scroll', sync, { passive: true });
    /* Chrome gives a horizontal scroller arrows but not Home/End. */
    row.addEventListener('keydown', function (ev) {
      if (ev.target !== row || (ev.key !== 'Home' && ev.key !== 'End')) return;
      ev.preventDefault();
      row.scrollTo({ left: ev.key === 'Home' ? 0 : row.scrollWidth, behavior: reducedMotion() ? 'auto' : 'smooth' });
    });
    if (w.ResizeObserver) new w.ResizeObserver(sync).observe(row);
    else w.addEventListener('resize', sync);
    sync();
  }

  /* One half of the glance row: "☀ AM" / "☽ PM" label, then its tiles, in a
     group named "Morning, 5 steps". Same markup as snippets/sts-glance-group.liquid. */
  function glanceHalf(h, parent) {
    var am = h === 'AM';
    var box = document.createElement('div');
    box.className = 'sts-hero__half';
    box.setAttribute('role', 'group');
    var label = document.createElement('span');
    label.className = 'sts-hero__half-label';
    label.setAttribute('aria-hidden', 'true');
    var glyph = document.createElement('span');
    glyph.textContent = am ? '☀' : '☽';
    label.appendChild(glyph);
    label.appendChild(document.createTextNode(h));
    var list = document.createElement('ol');
    list.className = 'sts-hero__half-list';
    list.setAttribute('role', 'list');
    box.appendChild(label);
    box.appendChild(list);
    parent.appendChild(box);
    return {
      list: list,
      n: 0,
      count: function (k) {
        box.style.flexGrow = String(k);
        box.setAttribute('aria-label', (am ? 'Morning, ' : 'Evening, ') + k + (k === 1 ? ' step' : ' steps'));
      }
    };
  }

  function fillGuestTiles() {
    var type = currentType();
    all('[data-sts-glance-tiles]').forEach(function (list) {
      if (list.__stsType && list.__stsType !== type) {
        list.textContent = '';
        list.__stsType = null;
        list.__stsTiles = false;
      }
      if (list.__stsTiles) return;
      list.__stsTiles = true;
      deviceSteps().then(function (steps) {
        if (list.children.length) return;         // drawn already; keep the guard
        /* The state moved on while this was pending (the simulator, a sign-in):
           its sts:state found this list busy and returned, so draw again for
           the type now resolved rather than the one captured at the start. */
        if (currentType() !== type) { list.__stsTiles = false; fillGuestTiles(); return; }
        /* No routine on this device YET: a sign-in or a finished quiz fires
           sts:state, and refresh() asks again. */
        if (!steps || !steps.length) { list.__stsTiles = false; return; }
        if (!drawTiles(list, steps, type)) list.__stsTiles = false;
      });
    });
  }

  /* The tiles for `steps` into `list` (a .sts-hero__swatches): the guest's
     from the device, and (v6.1 1.5b) anyone's again when Add to my routine
     changes the routine on this page, the server-drawn card included. Each
     tile is the step product's first Shopify image; an empty step keeps the
     numbered placeholder, with its category icon (tileImg). Returns how many
     tiles it drew. */
  function drawTiles(list, steps, type) {
        var frag = document.createDocumentFragment();
        var n = 0;
        var halves = {};
        var F = STS.stepFallback;
        /* A sold-out product shows its in-stock stand-in, as every surface does. */
        if (F) steps = steps.map(function (s) { return s && typeof s === 'object' ? F.standIn(s) : s; });
        /* AM 1..n then PM 1..m, off the shared normaliser (sts-state.js), each
           half in its own labelled group, as snippets/sts-glance-group.liquid
           draws the server tiles. A step with no time goes with the evening. */
        var rows = STS.orderRoutine ? STS.orderRoutine(steps) : steps;
        /* v7.1 section 3 (7.1-048): one product in two steps of the same half
           is ONE line ("Treatment & moisturizer"), so it is one tile, and the
           half is renumbered 1..n after merging, as the Skin Profile numbers
           its lines (assets/sts-routine-merge.js). Display only: the routine
           is still step -> product. An AM+PM product stays in both halves
           with the badge. A step with no product (key "i...") never merges. */
        var drawn = {}, per = { AM: 0, PM: 0 };
        rows = rows.filter(function (step) {
          if (!step || typeof step !== 'object') return false;
          var k = glanceKey(step), h = step.half === 'AM' ? 'AM' : 'PM';
          if (k.charAt(0) !== 'i') {
            if (drawn[h + k]) return false;
            drawn[h + k] = true;
          }
          if (STS.orderRoutine) step.n = ++per[h];
          return true;
        });
        /* Products used morning AND night (an AM+PM step, or one product in
           both halves) carry the ⇆ badge in both; P counts each product once.
           The same rules as snippets/sts-glance-count.liquid. */
        var twice = {}, seen = {}, halfOf = {}, products = 0;
        rows.forEach(function (step) {
          if (!step || typeof step !== 'object') return;
          var k = glanceKey(step), h = step.half === 'AM' ? 'AM' : 'PM';
          if (step.time === 'BOTH' || (halfOf[k] && halfOf[k] !== h)) twice[k] = true;
          halfOf[k] = h;
          if (!seen[k]) { seen[k] = true; products++; }
        });
        rows.slice(0, GLANCE_MAX).forEach(function (step) {
          if (!step || typeof step !== 'object') return;
          var h = step.half === 'AM' ? 'AM' : 'PM';
          var g = halves[h] || (halves[h] = glanceHalf(h, frag));
          var li = document.createElement('li');
          var b = twice[glanceKey(step)] ? 1 : 0;
          li.className = 'sts-hero__swatch sts-hero__swatch--b' + b;
          li.tabIndex = 0;
          li.__stsNamed = !!(step.title || step.name || step.productTitle);
          n++;
          li.__stsN = step.n || n;
          li.__stsB = b;
          /* An empty step never takes the eye placeholder's name, ECS /
             "Eye Cream Specific" (STS.stepLabel, sts-state.js). */
          var nm = step.included === false ? step.label || step.category || step.slot || '' : step.title || step.name || step.productTitle || step.slot || '';
          if (glanceKey(step).charAt(0) === 'i' && STS.stepLabel) {
            nm = STS.stepLabel(step, ['title', 'name', 'productTitle', 'slot']) || (STS.slotFam(step.slot) === 'E' ? 'Eye cream' : '');
          }
          if (step.substituted === true && step.substitutedFrom && step.included !== false) nm = standInName(step);
          nameTile(li, nm);
          var num = document.createElement('span');
          num.className = 'sts-hero__swatch-n';
          num.setAttribute('aria-hidden', 'true');
          num.textContent = String(li.__stsN);
          li.appendChild(num);
          li.insertAdjacentHTML('beforeend', '<span class="sts-hero__swatch-both" aria-hidden="true">⇆</span>');
          g.list.appendChild(li);
          g.count(++g.n);

          /* The widget shape carries `image`, the legacy one `imageUrl`. A step
             with neither, no handle and no variant - a prescription, a
             write-in, an empty slot - keeps its numbered tile, with the
             category icon (tileImg). Nothing is guessed. v6.1 1.5b: the
             product's first Shopify image, so a URL that is not Shopify's
             yields to the handle's featured image; an emptied step
             (included:false) keeps the placeholder. */
          if (!F) return;
          var src = step.image || step.imageUrl || step.image_url;
          tileImg(li, step.included === false ? { slot: step.slot }
            : src && step.handle && !/cdn\.shopify\.com|\/cdn\/shop\//.test(src) ? Object.assign({}, step, { image: null, imageUrl: null, image_url: null }) : step);
          if (!li.__stsNamed && step.included !== false) F.lookup(step).then(function (p) { if (p && p.title) nameTile(li, p.title); });
        });
        if (!n) return 0;
        list.appendChild(frag);
        watchSwatchRow(list);
        list.__stsType = type;
        fillStepCount(rows.length, type, products);
        return n;
  }

  /* v6.1 1.5b: Add to my routine on this page (the rows below, the widget)
     changed the routine, or put back this visit's change after a reload
     (sts-add-routine.js): every glance card redraws from it. */
  function redrawTiles(e) {
    var r = e && e.detail, steps = r && (r.steps || (r.doc && r.doc.steps)), type = currentType();
    if (!Array.isArray(steps) || !steps.length || !type) return;
    all('.sts-hero__swatches').forEach(function (list) {
      list.textContent = '';
      list.__stsTiles = true;
      drawTiles(list, steps, type);
    });
  }
  document.addEventListener('sts:routine:updated', redrawTiles);
  document.addEventListener('sts:routine:reverted', redrawTiles);

  // ------------------------------------------- library row, guest reorder (07-W14b)

  function byPos(a, b) {
    return (parseInt(a.getAttribute('data-sts-pos'), 10) || 0) - (parseInt(b.getAttribute('data-sts-pos'), 10) || 0);
  }

  function rankLibrary() {
    var L = STS.library;
    if (!L || typeof L.rankNodes !== 'function') return;
    var topics = typeof L.topics === 'function' ? L.topics() : [];
    var type = currentType();

    all('[data-sts-lib-pool]').forEach(function (pool) {
      if (pool.hasAttribute('data-sts-lib-server-ranked')) return;

      if (!topics.length && !type) {
        /* Nothing to rank by. Put the server order back if an earlier pass
           moved anything, otherwise leave the DOM alone. */
        if (pool.getAttribute('data-sts-lib-reordered') === '1') {
          all('[data-sts-pos]', pool).sort(byPos).forEach(function (n) { pool.appendChild(n); });
          pool.removeAttribute('data-sts-lib-reordered');
        }
        return;
      }

      var ranked = L.rankNodes(pool, { topics: topics, type: type }) || [];
      var hit = [];
      var rest = [];
      ranked.forEach(function (it) {
        if (!it || !it.node) return;
        ((it.score > 0 || it.typeMatch > 0) ? hit : rest).push(it.node);
      });
      rest.sort(byPos);
      hit.concat(rest).forEach(function (n) { pool.appendChild(n); });
      pool.setAttribute('data-sts-lib-reordered', '1');
    });
  }

  function rankLibraryWhenReady() {
    if (STS.library) { rankLibrary(); return; }
    document.addEventListener('DOMContentLoaded', rankLibrary);
    w.addEventListener('load', rankLibrary);
  }

  // ---------------------------------------------------- quiz links (09 §6.9)

  var PLACEMENTS = [
    ['[data-sts-home-hero]', 'hero'],
    ['.sts-drb', 'drb_band'],
    ['[data-sts-slider]', 'banner'],
    ['[data-sts-type-grid]', 'type_grid'],
    ['[data-sts-home-row="not_for_everyone"]', 'wrong_products'],
    ['.sts-finalcta', 'stop_guessing']
  ];

  function placementOf(el) {
    for (var i = 0; i < PLACEMENTS.length; i++) {
      if (el.closest(PLACEMENTS[i][0])) return PLACEMENTS[i][1];
    }
    return null;
  }

  /* A quiz link is a same-site /pages/…quiz… URL that is not a results page, so
     a merchandiser's own quiz_url setting still counts. */
  function quizUrl(a) {
    var url;
    try { url = new URL(a.getAttribute('href'), w.location.href); } catch (e) { return null; }
    if (url.origin !== w.location.origin) return null;
    var path = url.pathname.toLowerCase();
    if (!/\/pages\/[^/]*quiz/.test(path) || /result/.test(path)) return null;
    return url;
  }

  function monthsSince(iso) {
    var ms = Date.now() - Date.parse(iso || '');
    if (!(ms > 0)) return null;
    return Math.max(0, Math.round(ms / (30.44 * 24 * 60 * 60 * 1000)));
  }

  function onQuizClick(ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
    if (!a) return;
    var placement = placementOf(a);
    if (!placement) return;
    var url = quizUrl(a);
    if (!url) return;
    var st = STS.state || {};
    if (/(?:^|[?&])retake=1(?:&|$)/.test(url.search)) {
      track('sts_retake_quiz_click', { placement: placement, months_since_quiz: monthsSince(st.typedAt) });
    } else if (st.name === 'qpartial') {
      track('sts_resume_quiz_click', { placement: placement, quiz_pct: st.quiz ? st.quiz.pct : null });
    } else {
      track('sts_quiz_cta_click', { placement: placement });
    }
  }

  // ------------------------------------------------------------------- boot

  function boot() {
    fillTypeHrefs();
    all('[data-sts-slider][data-sts-slider-autoplay]').forEach(initSlider);
    all('[data-sts-type-grid]').forEach(initTypeGrid);
    markOwnType();
    all('[data-sts-glance]').forEach(initGlance);
    all('.sts-hero__swatches').forEach(watchSwatchRow);
    repairTiles();
    fillGuestTiles();
    fillRows();
    rankLibraryWhenReady();
  }

  function refresh() {
    fillTypeHrefs();
    markOwnType();
    fillGuestTiles();
    fillRows();
    rankLibrary();
  }

  /* The public surface spec §3.5 asks for. `rows` is where workstream 05 can hang a
     re-render when liked brands change in the same session. */
  STS.home = {
    rows: { picked: fillRows, library: rankLibrary },
    refresh: refresh
  };

  document.addEventListener('click', onQuizClick);

  document.addEventListener('sts:state', refresh);
  document.addEventListener('sts:library:topics', rankLibrary);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
}());
